var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 17,
    viewBox: "0 0 20 17",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h20v17h-20z",
    fill: "transparent"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#464d57"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.9918 6.39846.8521.80947.8947.85208c.0213-1.40593-1.2569-2.64144-2.7906-2.57753z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.99771 3.78739c2.50849 0 4.54439 1.91369 4.54439 4.27161 0 .55104-.1181 1.07645-.3226 1.55912l2.5451 2.42538c1.1716-.9159 2.471-2.34318 3.2354-3.9845-1.723-3.49245-5.5147-6.47471-10.00225-6.4074-1.27245 0-2.45433.2512-3.58588.63565l1.92718 1.80341c.51346-.18794 1.07243-.30327 1.65866-.30327z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.908868 1.45925 2.072252 1.94785.5337.49902c-1.36332 1.02249-2.620139 2.44972-3.51482 4.15276 1.93848 3.53722 5.38939 6.40742 9.99772 6.40742 1.31358 0 2.65558-.2287 3.95508-.74l.4167.3812 2.6494 2.4946 1.1588-1.085-16.11001-15.147105zm5.026152 4.72014 1.45675 1.34805c-.0426.19172-.06391.36163-.06391.55385 0 1.44854 1.23552 2.62011 2.70534 2.59881.2045 0 .4482-.0254.6391-.0639l1.3204 1.2615c-.6044.2819-1.2769.4528-1.99498.4528-2.50851 0-4.54443-1.9137-4.54443-4.27162 0-.6749.1818-1.30711.48173-1.87949z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eye-closed.e2087cbe49a0ccc39dd4ec1702990a32.svg";
export { ForwardRef as ReactComponent };